import axios, { AxiosResponse } from 'axios';
import Cookies from 'universal-cookie';

import { CookiesKeys } from 'enums/cookies-keys.enum';
import { IVipUserResponse } from 'models/vip/i-vip-user.interface';

export const getVipUser = (signal: AbortSignal): Promise<AxiosResponse<IVipUserResponse>> => {
  return axios.get('/api/v1/vip/user/', {
    signal,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};